<template>
  <div>
    <!-- Payment proceeding -->
    <v-card
      v-if="paymentSheetShow"
      outlined
    >
      <v-card-text>
        <v-row class="pa-0">
          <v-col cols="4">
            <v-checkbox
              v-model="order.method"
              class="mx-2"
              label="Live"
            />
            <v-col
              v-if="order.method"
              cols="12"
            >
              <v-text-field
                v-model="order.enterAmount"
                hide-details="auto"
                label="Enter Amount"
                outlined
                type="number"
                dense
              />
            </v-col>
          </v-col>
          <v-col cols="8">
            <v-simple-table dense>
              <template>
                <thead>
                  <tr>
                    <th>Amount</th>
                    <th>Tax {{ order.taxRate }}%</th>
                    <th>Discount {{ order.discountRate }}%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ price | currency }}</td>
                    <td>
                      +{{ taxAmount | currency }} |
                      {{ totalWithTax | currency }}
                    </td>
                    <td>
                      -{{ discountAmount | currency }}
                      |
                      {{ totalAfterDiscount | currency }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <h3>
                        ({{ items }} items) Payable :
                        {{ totalAfterDiscount | currency }}
                      </h3>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3">
                      <h3>
                        Return change:
                        {{ change | currency }}
                      </h3>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <template v-if="order.method">
          <v-row>
            <v-col
              cols="12"
              md="8"
              sm="8"
            >
              <v-col cols="12">
                <v-select
                  v-model="order.gateway"
                  :items="gateways"
                  outlined
                  label="Select gateway"
                  dense
                />
                <v-textarea
                  v-model="order.note"
                  label="Payment Note"
                  outlined
                  rows="5"
                  dense
                />
              </v-col>
            </v-col>
            <v-col
              class="pa-0"
              cols="12"
              md="4"
              sm="4"
            >
              <v-btn
                v-for="key in keys"
                :key="key"
                class="info mt-1 ml-1"
                @click="press(key)"
              >
                {{ key }}
              </v-btn>
              <v-btn
                class="warning mt-1  ml-1"
                @click="padClear()"
              >
                d
              </v-btn>
              <v-btn
                class="red mt-1 ml-0"
                @click="padClear('all')"
              >
                c
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <template v-else>
          <v-col cols="12">
            <v-date-picker
              v-model="order.dueDate"
              landscape
              full-width
              label="Due Date"
            />
          </v-col>
        </template>

        <v-btn
          class="info"
          :disabled="preCheck"
          @click="submitSale"
        >
          Process
        </v-btn>
        <v-btn
          class="warning"
          @click="switchToPay"
        >
          Back
        </v-btn>
        <template v-if="preCheck">
          <div class="red--text">
            Please select customer for due payment !
          </div>
        </template>
      </v-card-text>
    </v-card>
    <!-- end -->

    <!-- POS cart -->
    <v-card
      v-else
      outlined
    >
      <!-- Cart table -->
      <v-card-text>
        <v-simple-table
          height="290px"
          dense
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Name
                </th>
                <th class="text-left">
                  #Code
                </th>
                <th class="text-left">
                  Price
                </th>
                <th class="text-left">
                  QTY
                </th>
                <th class="text-left">
                  Disc %
                </th>
                <th class="text-left">
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in products"
                :key="item.id"
              >
                <td>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        class="error--text"
                        @click="removeItem(item)"
                        v-on="on"
                      >
                        mdi-minus-circle
                      </v-icon>
                    </template>
                    <span>Remove {{ item.name | capitalize }}</span>
                  </v-tooltip>

                  {{ item.name | capitalize }}
                </td>
                <td @click="editItem(item)">
                  {{ item.sku }}
                </td>
                <td @click="editItem(item)">
                  {{ item.price | currency }}
                </td>
                <td @click="editItem(item)">
                  {{ item.qty }}
                </td>
                <td :class="item.discount > 0 ? 'red--text' : 'success--text'">
                  {{ item.discount }}%
                </td>
                <td>
                  {{ item.subTotal | currency }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <!-- end -->

      <!-- Cart actions -->
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-simple-table dense>
              <template>
                <tbody class="text-right">
                  <tr class="active">
                    <th class="text-left">
                      Amount ({{ items }} items) :
                    </th>
                    <td>{{ price | currency }}</td>
                  </tr>

                  <tr
                    v-if="order.shippingAmount > 0"
                    class="active"
                  >
                    <th class="text-left">
                      With Shipping : {{ order.shippingAmount | currency }}
                    </th>
                    <td>{{ withShipping | currency }}</td>
                  </tr>

                  <tr
                    v-if="order.taxRate > 0"
                    class="active"
                  >
                    <th class="text-left">
                      With Tax : {{ order.taxRate }}% |
                      {{ taxAmount | currency }}
                    </th>
                    <td>{{ totalWithTax | currency }}</td>
                  </tr>

                  <tr
                    v-if="order.discountRate > 0"
                    class="active"
                  >
                    <th class="text-left">
                      After Discount : {{ order.discountRate }}% |
                      {{ discountAmount | currency }}
                    </th>
                    <td>{{ totalAfterDiscount | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <template v-if="products.length > 0">
          <v-row class="pl-2">
            <v-col
              class="pa-1"
              cols="12"
              md="3"
              sm="12"
            >
              <v-text-field
                v-model="order.taxRate"
                type="number"
                label="Tax %"
                hide-details="auto"
                dense
                outlined
              />
            </v-col>
            <v-col
              class="pa-1"
              cols="12"
              md="3"
              sm="12"
            >
              <v-text-field
                v-model="order.discountRate"
                type="number"
                label="Discount %"
                hide-details="auto"
                :disabled="posConf.stopDiscount"
                dense
                outlined
              />
            </v-col>
            <v-col
              class="pa-1"
              cols="12"
              md="6"
              sm="12"
            >
              <v-btn
                class="info mb-1"
                @click="toggleShoppingModel"
              >
                <v-icon>
                  mdi-note-text
                </v-icon>
              </v-btn>
              <v-btn
                class="yellow mb-1"
                @click="cartClearWarningShow"
              >
                <v-icon>
                  mdi-close-circle-outline
                </v-icon>
              </v-btn>
              <v-btn
                class="success mb-1"
                @click="switchToPay"
              >
                <v-icon>
                  mdi-cash
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <!-- end -->
    </v-card>
    <!-- end -->

    <!-- Shipping -->
    <v-dialog
      v-model="shippingSheetShow"
      width="500"
    >
      <v-card>
        <v-card-text>
          <v-tabs>
            <v-tab>
              <v-icon class="mr-2">
                mdi-note-plus
              </v-icon> Sale Note
            </v-tab>
            <v-tab>
              <v-icon class="mr-2">
                mdi-truck-fast
              </v-icon> Shipping
              Info
            </v-tab>
            <v-tab-item class="mt-3">
              <v-col cols="12">
                <v-text-field
                  v-model="order.noteTitle"
                  hide-details="auto"
                  label="Title"
                  placeholder="Warranty, Warning, Additional Reference"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="order.saleNote"
                  label="Note"
                  outlined
                  rows="5"
                  dense
                />
                <v-switch
                  v-model="order.printNote"
                  class="mt-1"
                  label="Display In Print"
                  hide-details
                />
              </v-col>
            </v-tab-item>
            <v-tab-item class="mt-3">
              <div class="d-flex">
                <v-col cols="6">
                  <v-text-field
                    v-model="order.shippingAmount"
                    hide-details="auto"
                    type="number"
                    label="Shipping Amount"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="order.shippingRecipient"
                    hide-details="auto"
                    label="Recipient"
                    outlined
                    dense
                  />
                </v-col>
              </div>
              <v-col cols="12">
                <v-textarea
                  v-model="order.shippingInfo"
                  label="Shipping To"
                  outlined
                  rows="5"
                  dense
                />
              </v-col>
            </v-tab-item>
          </v-tabs>
          <v-btn
            color="warning"
            small
            @click="toggleShoppingModel"
          >
            Confirmed
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- shipping ends -->

    <!-- cart clear warning start -->
    <v-dialog
      v-model="cartClearWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to clear cart items ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="cartClearWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="warning darken-1"
            text
            @click="clearCart"
          >
            Yes Clear
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- warning ends -->

    <!--Edit cart item -->
    <v-dialog
      v-model="editCartDialog"
      width="500"
    >
      <v-card>
        <v-card-title>
          <v-icon class="mr-2">
            mdi-pencil-circle-outline
          </v-icon>
          Editing : " {{ edited.name | capitalize }} "
        </v-card-title>
        <v-card-text class="mt-3">
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="edited.name"
                hide-details="auto"
                label="Item Name"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="edited.price"
                hide-details="auto"
                label="Price"
                type="number"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="edited.qty"
                hide-details="auto"
                label="QTY"
                outlined
                type="number"
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="edited.discount"
                hide-details="auto"
                :label="
                  isDicountable ? 'Discount Not allowed' : 'Discount Allowed %'
                "
                type="number"
                outlined
                :disabled="isDicountable"
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="edited.imei"
                hide-details="auto"
                label="IMEI"
                outlined
                dense
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="edited.sNumber"
                hide-details="auto"
                label="Serial Number"
                outlined
                dense
              />
            </v-col>

            <v-chip-group mandatory>
              <v-chip
                v-for="item in edited.variants"
                :key="item.variant"
                color="info"
                @click="changeVariant(item)"
              >
                {{ item.variant | capitalize }}: {{ item.price | currency }}+
              </v-chip>
            </v-chip-group>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="closeDialog"
          >
            Done
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- edit end -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      value: "",
      keys: [...Array(10).keys()],
      gateways: ["card", "cheque", "cash", "other"],
      cartClearWarning: false,
      shippingSheetShow: false,
      paymentSheetShow: false,
      sale: {},
      edited: {},
      editCartDialog: false,
      order: {
        enterAmount: "",
        discountRate: 0,
        shippingAmount: 0,
        shippingRecipient: null,
        shippingInfo: null,
        taxRate: 0,
        method: true,
        customer_id: null,
        gateway: "cash",
        note: "None",
        noteTitle: "",
        saleNote: "",
        printNote: false,
        dueDate: new Date().toISOString().substr(0, 10),
      },
    };
  },
  computed: {
    ...mapGetters({
      products: "cart/items",
      items: "cart/totalQty",
      price: "cart/totalPrice",
      posConf: "configs/pos",
    }),
    isDicountable() {
      let item = this.$data.edited;
      if ("data" in item) {
        return !item.data.discounted;
      }
      return true;
    },

    preCheck() {
      if (!this.order.method && !this.order.customer_id) {
        return true;
      }
      return false;
    },

    withShipping() {
      return this.price + Number(this.$data.order.shippingAmount);
    },
    taxAmount() {
      return this.withShipping * (this.$data.order.taxRate / 100);
    },
    totalWithTax() {
      if (this.posConf.isTaxIncluded) {
        return this.withShipping;
      } else {
        return this.withShipping + this.taxAmount;
      }
    },
    discountAmount() {
      return this.totalWithTax * (this.$data.order.discountRate / 100);
    },
    totalAfterDiscount() {
      return this.totalWithTax - this.discountAmount;
    },

    change() {
      return this.order.enterAmount - this.totalAfterDiscount;
    },
  },

  watch: {
    edited: {
      handler(qty) {
        let discountAmount = qty;
        const price = this.edited.price;
        const quantity = this.edited.qty;
        const discount = this.edited.discount;
        const subTotal = price * quantity;
        discountAmount = subTotal * (discount / 100);
        this.edited.subTotal = subTotal - discountAmount;
      },
      deep: true,
    },
    totalAfterDiscount() {
      this.$data.order.enterAmount = this.totalAfterDiscount;
    },
  },

  created() {
    Event.$on("saleCustomer", (id) => {
      return (this.$data.order.customer_id = id);
    });
  },
  mounted() {
    this.$data.order.taxRate = this.posConf.defaultTaxRate;
    this.$data.order.discountRate = this.posConf.defaultDiscountRate;
    if (this.posConf.stopDiscount) {
      this.$data.order.discountRate = 0;
    }
  },
  methods: {
    ...mapActions({
      removeItem: "cart/remove",
      clearCartItems: "cart/clear",
      feedback: "snackbar/show",
      saleForPrint: "misc/saleForPrint",
    }),
    changeVariant(child) {
      const price = this.$data.edited.actuallPrice;
      const name = this.$data.edited.actuallName;
      this.$data.edited.price = Number(child.price) + Number(price);
      this.$data.edited.name = name + "(" + child.variant + ")";
    },
    switchToPay() {
      this.paymentSheetShow = !this.paymentSheetShow;
      this.fireFocusEvent();
    },
    fireFocusEvent() {
      Event.$emit("stopFocusingStateChange");
    },
    toggleShoppingModel() {
      this.shippingSheetShow = !this.shippingSheetShow;
      this.fireFocusEvent();
    },
    closeDialog() {
      this.$data.editCartDialog = false;
      this.fireFocusEvent();
    },
    editItem(item) {
      this.$data.edited = item;
      this.$data.edited.actuallPrice = item.data.price;
      this.$data.edited.actuallName = item.data.name;
      this.$data.edited.variants = item.data.variants;
      this.$data.editCartDialog = true;
      this.fireFocusEvent();
    },
    prepareSale() {
      this.$data.order.salling = true;
      this.$data.order.subTotal = this.price;
      this.$data.order.taxAmount = this.taxAmount;
      this.$data.order.discountedAmount = this.discountAmount;
      this.$data.order.totalAmount = this.totalAfterDiscount;
      this.$data.order.totalItems = this.items;
      this.$data.order.items = this.products;
      return this.$data.order;
    },
    submitSale() {
      window.axios
        .post("/sale", this.prepareSale())
        .then((response) => {
          this.feedback(response.data.message);
          Event.$emit("salePlaced");
          this.saleForPrint(response.data.id);
          this.clearCartItems();
        })
        .catch((error) => {
          this.feedback(error.data.error);
        });
    },
    press(key) {
      this.order.enterAmount += key;
    },

    padClear(type) {
      if (type === "all") {
        this.order.enterAmount = "";
      } else
        this.order.enterAmount = this.order.enterAmount.substring(
          0,
          this.order.enterAmount.length - 1
        );
    },

    clearCart() {
      this.clearCartItems();
      this.$data.cartClearWarning = false;
    },
    cartClearWarningShow() {
      this.$data.cartClearWarning = true;
    },
  },
};
</script>
